import FinanceUtil from '../helpers/FinanceUtil'
//import loan from './testData/loan'

describe('FinanceUtil', () => {
  let financeUtil, amount, product, loan
  beforeEach(() => {
    product = {
      productType: "sba7a",
      term: 120,
      spread: 7.99,
      prime: 0,
      tierRates: "[{\"max_loan_amount\":25000,\"spread\":4.75,\"fees\":{\"guaranty_1\":0.017,\"packaging\":0.02,\"referral\":0.02,\"fixed\":22.8}},{\"max_loan_amount\":49999,\"spread\":3.75,\"fees\":{\"guaranty_1\":0.017,\"packaging\":0.02,\"referral\":0.02,\"fixed\":450.0}},{\"max_loan_amount\":125000,\"spread\":2.75,\"fees\":{\"guaranty_1\":0.017,\"packaging\":0.02,\"referral\":0.02,\"fixed\":450.0}},{\"max_loan_amount\":150000,\"spread\":2.75,\"fees\":{\"guaranty_1\":0.017,\"packaging\":0.02,\"referral\":0.02,\"fixed\":450.0}},{\"max_loan_amount\":350000,\"spread\":2.75,\"fees\":{\"guaranty_1\":0.0225,\"packaging\":0.02,\"referral\":0.02,\"fixed\":450.0}},{\"max_loan_amount\":700000,\"spread\":2.75,\"fees\":{\"guaranty_1\":0.0225,\"packaging\":0.005,\"referral\":0.005,\"fixed\":450.0}},{\"max_loan_amount\":5000000,\"spread\":2.75,\"fees\":{\"guaranty_1\":0.02625,\"guaranty_2\":0.028125,\"guaranty_step\":1333333.33,\"packaging\":0.005,\"referral\":0.005,\"fixed\":450.0}},{\"max_loan_amount\":10000000,\"spread\":2.75,\"fees\":{\"guaranty_1\":0,\"guaranty_2\":0,\"guaranty_step\":0,\"packaging\":0,\"referral\":0,\"fixed\":450.0}}]"
    }
    loan = {
      term: 120,
      spread: 19.99,
    }
    amount = 100000
    financeUtil = new FinanceUtil(amount, product, loan)
  })
  xdescribe('.monthlyPayment', () => {
    it('returns', () => {
      expect(Math.round(financeUtil.monthlyPayment)).toEqual(3715)
    })
  })
  describe('.finalSpread', () => {
    it('returns', () => {
      expect((financeUtil.finalSpread)).toEqual(2.75)
    })
  })
})
